module.exports = __webpack_public_path__ + "static/media/puan_small.451805b0.svg";